module.exports = __webpack_public_path__ + "img/DGD.a6d99b21.svg";